import React, { useState, useEffect } from 'react';
import './ScrollProgress.css';

/**
 * Scroll progress indicator component
 * Shows how far the user has scrolled down the page
 */
const ScrollProgress = ({ type = 'bar' }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      setProgress(Math.min(scrollPercent, 100));
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial calculation

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (type === 'circle') {
    const circumference = 2 * Math.PI * 22; // radius of 22
    const offset = circumference - (progress / 100) * circumference;

    return (
      <div className="scroll-progress-circle">
        <svg width="50" height="50" viewBox="0 0 50 50">
          <circle className="bg" cx="25" cy="25" r="22" />
          <circle
            className="progress"
            cx="25"
            cy="25"
            r="22"
            style={{ strokeDashoffset: offset }}
          />
        </svg>
      </div>
    );
  }

  return (
    <div
      className="scroll-progress-bar"
      style={{ width: `${progress}%` }}
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-label="Page scroll progress"
    />
  );
};

export default ScrollProgress;
